import { DateFilter, ValueRangeFilter, MultiChoiceFilter } from '@model';
import { MeteringType } from '@enums';

export class InvoiceFilter {
  dateFilter: DateFilter;
  amountValueRangeFilter: ValueRangeFilter;
  meteringType: MeteringType;
  typeMultiChoiceFilter: MultiChoiceFilter;
  statusMultiChoiceFilter: MultiChoiceFilter;
  payDateFilter: DateFilter;
}

